import React from "react";
import { useNavigate } from "react-router-dom";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import { asyncGetPlan } from "lib/store/user";
import { modalState } from "lib/store/common";

import { Button, InlineBox } from "@atsent/components";

import "./CurrentPlan.scss";

export const CurrentPlan: React.FC = () => {
  const navigate = useNavigate();

  const plan = useRecoilValueLoadable(asyncGetPlan);
  const setModal = useSetRecoilState(modalState);

  return (
    <InlineBox title={"Current Plan"} cx={"CurrentPlan"}>
      <div className="body">
        <div className="l">
          <strong>{plan.contents.type}</strong>
          <br />
          <br />
          <span className={"text"}>
            {plan.contents.type === "FREE" && (
              <>현재 무료 계정을 사용중입니다.</>
            )}
            {plan.contents.type === "STANDARD" && (
              <>현재 스탠다드 계정을 사용중입니다.</>
            )}
            {plan.contents.type === "BUSINESS" && (
              <>현재 비즈니스 계정을 사용중입니다.</>
            )}
            {plan.contents.type === "ENTERPRISE" && (
              <>현재 무제한 계정을 사용중입니다.</>
            )}
          </span>
        </div>
        {plan.contents.type === "FREE" && (
          <Button
            click={() => {
              setModal((m) => ({ ...m, myAccount: false }));
              navigate("/payment");
            }}
            size={"small"}
            outline
          >
            Upgrade Plan
          </Button>
        )}
      </div>
    </InlineBox>
  );
};
